export const isProduction = process.env.REACT_APP_ENV === 'production';

export const isStaging = process.env.REACT_APP_ENV === 'staging';

export const isDevelopment = window.location.hostname === 'localhost';

export const isDesktopApp = () =>
  typeof window !== 'undefined' && window.lifestack?.platform === 'darwin';
